module.exports = __webpack_public_path__ + "img/maquiagens.98acba0d.png";